class DonationBox extends HTMLElement {
  constructor() {
    super();
    this.cart = JSON.parse(document.getElementById('cartObj')?.textContent || '{}');
    this.cartItems = this.cart.items || [];
  }

  connectedCallback() {
    this.donationHeader = this.querySelector('.donation-box');
    this.donationButtons = this.querySelectorAll('.donation-box__button');
    this.donationPopUp = this.querySelector('.donation-box__popup');
    this.donationPopUpBtn = this.querySelector('.donation-box__popup-button');

    if (!this.isDonationInCart()) {
      this.donationHeader?.classList.remove('hidden');
    }

    this.donationButtons.forEach(button =>
      button.addEventListener('click', this.handleAddDonation.bind(this))
    );

    this.donationPopUpBtn?.addEventListener('click', () => {
      window.location.reload();
    });
  }

  isDonationInCart() {
    return this.cartItems.some(item => item.product_title.includes('Donation'));
  }

  async handleAddDonation(event) {
    event.preventDefault();
    const variantId = event.target.id;

    const formData = {
      items: [{ id: variantId, quantity: 1 }]
    };

    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });
      this.togglePopup();
    } catch (error) {
      console.error('Add to cart failed:', error);
    }
  }

  togglePopup() {
    this.donationPopUp?.classList.toggle('hidden');
  }
}

customElements.define('donation-box', DonationBox);